/**
 * Created by Ivan on 19.10.2026
 */

const DiscoParty = function (mission) {
    this.mission = mission;
    this.slots = this.mission.slots;

    const data = this.mission.details || {};
    this.won = data.won || [];
};

DiscoParty.prototype.getSlot = function (slot) {
    return this.slots[slot];
};

DiscoParty.prototype.getReward = function (slot) {
    return new RewardsList(this.getSlot(slot).reward, {
        event: cleverapps.EVENTS.EARN.DISCO_PARTY,
        toBubbleStack: true
    });
};

DiscoParty.prototype.isWon = function (slot) {
    return this.won.includes(slot);
};

DiscoParty.prototype.isAllWon = function () {
    return this.won.length >= this.slots.length;
};

DiscoParty.prototype.isFreeSpinAvailable = function () {
    return this.won.length === 0;
};

DiscoParty.prototype.listRemaining = function () {
    return this.slots.map((slot, index) => index).filter((index) => !this.isWon(index));
};

DiscoParty.prototype.calcChances = function () {
    const remaining = this.listRemaining();
    const lowestTier = Math.min(...remaining.map((slot) => this.getSlot(slot).tier));
    const lowest = remaining.filter((slot) => this.getSlot(slot).tier === lowestTier);
    const higher = remaining.filter((slot) => this.getSlot(slot).tier !== lowestTier);
    const higherChance = higher.reduce((sum, slot) => sum + this.getSlot(slot).chance, 0);
    const lowestShare = higher.length ? DiscoParty.LOWEST_TIER_SHARE : 1;

    const chances = {};
    lowest.forEach((slot) => {
        chances[slot] = lowestShare / lowest.length;
    });
    higher.forEach((slot) => {
        chances[slot] = (1 - lowestShare) * this.getSlot(slot).chance / higherChance;
    });

    return chances;
};

DiscoParty.prototype.pickSlot = function () {
    if (this.isFreeSpinAvailable()) {
        return this.slots.findIndex((slot) => slot.tier === 0);
    }

    const chances = this.calcChances();
    const remaining = Object.keys(chances).map(Number);
    const picked = PseudoRandom.GET().pickOne(remaining.map((slot) => chances[slot]));
    if (picked === undefined) {
        return remaining[remaining.length - 1];
    }

    return remaining[picked];
};

DiscoParty.prototype.spinFree = function () {
    return this.spin(0);
};

DiscoParty.prototype.getProduct = function () {
    return Product.CreateById(DiscoParty.PRODUCT, {
        type: "discoparty",
        mission: this.mission.getType()
    });
};

DiscoParty.prototype.getPrice = function () {
    return this.getProduct().getCurrentPrice();
};

DiscoParty.prototype.buy = function (callback) {
    this.getProduct().buy((success) => {
        callback(success ? this.spin(1) : undefined);
    });
};

DiscoParty.prototype.spin = function (spins) {
    const slot = this.pickSlot();

    this.won.push(slot);
    this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${slot}` });
    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, { reward: this.getSlot(slot).reward, itemId: `${slot}` });
    this.update(spins);

    if (this.isAllWon()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.mission.complete();
    }

    return slot;
};

DiscoParty.prototype.getInfo = function () {
    return {
        won: this.won
    };
};

DiscoParty.prototype.update = function (spins) {
    this.mission.update(spins, this.getInfo());
    this.mission.updateMissionIcon();
};

DiscoParty.prototype.isAttentionRequired = function () {
    return this.isFreeSpinAvailable();
};

DiscoParty.prototype.canRemove = () => true;
DiscoParty.prototype.canRemoveSilently = () => true;

DiscoParty.PRODUCT = "kit1";
DiscoParty.LOWEST_TIER_SHARE = 0.9;

DiscoParty.GetSlots = function () {
    return bundles.discoparty_slots.jsons.slots_config_json.getJson()[cleverapps.config.type];
};

DiscoParty.CanStart = function () {
    return Boolean(DiscoParty.GetSlots() && connector.payments.getProduct(DiscoParty.PRODUCT));
};

Restorable.BY_TYPE["discoparty"] = new Restorable({
    location: "main",
    find: Restorable.FindRunningMission,
    give: (mission) => {
        const reward = mission.logic.getReward(mission.logic.spin(1));
        Restorable.displayWindow("DiscoPartyRestore", () => new RewardWindow(reward));
    }
});
